import { useReveal } from "../hooks/useReveal";
import { SEO } from "../components/SEO";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Services } from "../components/Services";
import { Target } from "../components/Target";
import { About } from "../components/About";
import { Methodology } from "../components/Methodology";
import { Situations } from "../components/Situations";
import { Disclaimer } from "../components/Disclaimer";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";

const HOME_TITLE =
    "Données & Droit - Données personnelles et conformité réglementaire";
const HOME_DESCRIPTION =
    "Conseil en protection des données personnelles, pratiques numériques et conformité réglementaire pour dirigeants, indépendants et structures patrimoniales.";
const HOME_OG_TITLE =
    "Données & Droit | Données personnelles, pratiques numériques et conformité";
const HOME_OG_DESCRIPTION =
    "Conseil en protection des données personnelles, pratiques numériques et conformité réglementaire pour dirigeants, indépendants et structures patrimoniales.";

export function Home() {
    useReveal();
    return (
        <main data-testid="home-main">
            <SEO
                path="/"
                title={HOME_TITLE}
                description={HOME_DESCRIPTION}
                ogTitle={HOME_OG_TITLE}
                ogDescription={HOME_OG_DESCRIPTION}
            />
            <Header />
            <Hero />
            <Services />
            <Target />
            <Methodology />
            <Situations />
            <About />
            <Disclaimer />
            <Contact />
            <Footer />
        </main>
    );
}
